import { useCallback, useContext } from 'react';
import api from 'api';
import { Lead } from 'models/Lead';
import LeadsContext from '../providers/Leads';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import ReleaseFileLoadingContext from '../providers/ReleaseFileLoading';
import { getUpdatedAccessLevel } from '../components/LeadsTableContainer/utils';

type ReleaseFileForLeadArgs = {
  leadId: string;
  dataRoomNodeId: string;
  name: string;
  onSuccessRelease?: (lead: Lead) => void;
};

export default function useReleaseFileForLead() {
  const { popServerError } = useContext(PopNotificationsContext);
  const { showReleaseFileUndo } = useContext(LeadsContext);
  const { setReleaseFileLoadingForLead } = useContext(
    ReleaseFileLoadingContext,
  );
  return useCallback(
    async ({
      leadId,
      dataRoomNodeId,
      name,
      onSuccessRelease,
    }: ReleaseFileForLeadArgs) => {
      setReleaseFileLoadingForLead(leadId, dataRoomNodeId, true);

      try {
        const { data } = await api.portfolio.seller.releaseFileForLead(
          leadId,
          dataRoomNodeId,
        );

        onSuccessRelease?.(data);
        showReleaseFileUndo?.({
          leadId,
          dataRoomNodeId,
          name,
          accessLevel: getUpdatedAccessLevel(data, dataRoomNodeId),
        });
      } catch (e) {
        popServerError(e);
      } finally {
        setReleaseFileLoadingForLead(leadId, dataRoomNodeId, false);
      }
    },
    [popServerError, setReleaseFileLoadingForLead, showReleaseFileUndo],
  );
}
